import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TEXT_CONFIGS } from '../constants';
import CanvasMenuSelect from '../menu/CanvasMenuSelect';

export default class CanvasTextSize extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    onUpdate: PropTypes.func,
    updateInfo: PropTypes.func,
    fontSize: PropTypes.number
  };

  groupApplySize(size) {
    const { canvasRef, onUpdate, updateInfo } = this.props;

    const activeObjects = canvasRef.getActiveObjects();

    activeObjects.forEach((object) => {
      object.set({ fontSize: size.value });
    });

    canvasRef.renderAll();

    onUpdate();
    updateInfo();
  }

  render() {
    const { fontSize } = this.props;
    const sizes = TEXT_CONFIGS.DEFINED_FONT_SIZES;

    return (
      <CanvasMenuSelect
        onChange={this.groupApplySize.bind(this)}
        options={sizes}
        value={fontSize}
        placeholder={`${fontSize || ' '}`}
        toolTip="canvas-editor.text.font.size"
        className="canvas-menu__select-font-size"
        translatable={false}
      />
    );
  }
}
